import React, { Component } from 'react';
import { ReCaptcha } from 'react-recaptcha-google'
import config from "../../config";

class GoogleCaptchaComponent extends Component {
    constructor(props, context) {
        super(props, context);
        this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
    }

    componentDidMount() {
        if (this.captchaDemo) {

            this.captchaDemo.reset();
            this.props.resetCaptcha();
        }
    }

    onLoadRecaptcha() {
        if (this.captchaDemo) {
            this.captchaDemo.reset();
            this.props.resetCaptcha();
        }
    }

    verifyCallback(recaptchaToken) {
        // Here you will get the final recaptchaToken!!!
        this.props.responseToken(recaptchaToken)
    }

    render() {
        return (
            <div>
                {/* You can replace captchaDemo with any ref word */}
                <ReCaptcha
                    ref={(el) => {this.captchaDemo = el;}}
                    size="normal"
                    data-theme="dark"
                    render="explicit"
                    sitekey={config.googleSiteKey}
                    onloadCallback={this.onLoadRecaptcha}
                    verifyCallback={this.verifyCallback}
                />

            </div>
        );
    };
};

export default GoogleCaptchaComponent;